module.exports = __webpack_public_path__ + "img/bgi1.f3f3205d.png";